export default Object.freeze({
  today: new Date().toISOString().slice(0, 10),
  timeOptions: [
    "09:00",
    "09:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
    "22:30",
    "23:00",
    "23:30",
  ],
  numberOptions: [
    { state: "1名", abbr: 1 },
    { state: "2名", abbr: 2 },
    { state: "3名", abbr: 3 },
    { state: "4名", abbr: 4 },
    { state: "5名", abbr: 5 },
    { state: "6名", abbr: 6 },
    { state: "7名", abbr: 7 },
    { state: "8名", abbr: 8 },
    { state: "9名", abbr: 9 },
    { state: "10名", abbr: 10 },
  ],
  genreOptions: [
    { state: "寿司", abbr: 1 },
    { state: "焼肉", abbr: 2 },
    { state: "居酒屋", abbr: 3 },
    { state: "イタリアン", abbr: 4 },
    { state: "ラーメン", abbr: 5 },
  ],
  destinationOptions: [
    { state: "全てのユーザーとオーナー", abbr: 0 },
    { state: "全てのユーザー", abbr: 1 },
    { state: "全てのオーナー", abbr: 2 },
  ],
  Prefectures: [
    "北海道",
    "青森県",
    "岩手県",
    "宮城県",
    "秋田県",
    "山形県",
    "福島県",
    "茨城県",
    "栃木県",
    "群馬県",
    "埼玉県",
    "千葉県",
    "東京都",
    "神奈川県",
    "新潟県",
    "富山県",
    "石川県",
    "福井県",
    "山梨県",
    "長野県",
    "岐阜県",
    "静岡県",
    "愛知県",
    "三重県",
    "滋賀県",
    "京都府",
    "大阪府",
    "兵庫県",
    "奈良県",
    "和歌山県",
    "鳥取県",
    "島根県",
    "岡山県",
    "広島県",
    "山口県",
    "徳島県",
    "香川県",
    "愛媛県",
    "高知県",
    "福岡県",
    "佐賀県",
    "長崎県",
    "熊本県",
    "大分県",
    "宮崎県",
    "鹿児島県",
    "沖縄県",
  ],
});
